import { apiAuth, apiResponseType } from ".";
import { AdjustmentFilters } from "@/App/WalletOperations/Adjustments/types";

export const getBalanceAdjustmentRequests = (
  filters: AdjustmentFilters = {}
): apiResponseType =>
  apiAuth.get("balance-adjustment-requests", {
    params: { ...filters },
  }) as apiResponseType;

export const getBalanceAdjustmentReasons = (): apiResponseType =>
  apiAuth.get("balance-adjustment-requests/reasons") as apiResponseType;

export const storeBalanceAdjustmentRequest = (payload: {
  client_id: number;
  type: "add" | "subtract";
  amount: number;
  reason_id: number;
  description: string;
  files: File[];
}): apiResponseType => {
  const formData = new FormData();
  formData.append("client_id", String(payload.client_id));
  formData.append("type", payload.type);
  formData.append("amount", String(payload.amount));
  formData.append("reason_id", String(payload.reason_id));
  formData.append("description", payload.description);
  payload.files.forEach((file) => formData.append("files[]", file));

  return apiAuth.post("balance-adjustment-requests/store", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }) as apiResponseType;
};

export const approveBalanceAdjustmentRequest = (uuid: string): apiResponseType =>
  apiAuth.post(`balance-adjustment-requests/${uuid}/approve`) as apiResponseType;

export const rejectBalanceAdjustmentRequest = (
  uuid: string,
  reviewNotes?: string
): apiResponseType =>
  apiAuth.post(`balance-adjustment-requests/${uuid}/reject`, {
    review_notes: reviewNotes || undefined,
  }) as apiResponseType;
